import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=e67ca60c"
import script from "./logo.vue?vue&type=script&lang=ts"
export * from "./logo.vue?vue&type=script&lang=ts"
import style0 from "./logo.vue?vue&type=style&index=0&id=e67ca60c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports